module.exports = __webpack_public_path__ + "img/exercise-sample.f17e83f6.png";